/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CategoryNew_lists$ref = any;
export type CategoryNewQueryVariables = {||};
export type CategoryNewQueryResponse = {|
  +lists: ?{|
    +$fragmentRefs: CategoryNew_lists$ref
  |}
|};
export type CategoryNewQuery = {|
  variables: CategoryNewQueryVariables,
  response: CategoryNewQueryResponse,
|};
*/


/*
query CategoryNewQuery {
  lists {
    ...CategoryNew_lists
    id
  }
}

fragment CategoryNew_lists on Lists {
  id
}
*/

const node/*: ConcreteRequest*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CategoryNewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CategoryNew_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CategoryNewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CategoryNewQuery",
    "operationKind": "query",
    "text": "query CategoryNewQuery {\n  lists {\n    ...CategoryNew_lists\n    id\n  }\n}\n\nfragment CategoryNew_lists on Lists {\n  id\n}\n"
  }
};
// prettier-ignore
(node/*: any*/).hash = '9d6641383ccabf07e6ad8af88f7d1531';

module.exports = node;
